__turbopack_context__.v({
  "buttonWrapper": "mailingListForm-module-scss-module___aD7VG__buttonWrapper",
  "description": "mailingListForm-module-scss-module___aD7VG__description",
  "fieldWrapper": "mailingListForm-module-scss-module___aD7VG__fieldWrapper",
  "formRow": "mailingListForm-module-scss-module___aD7VG__formRow",
  "mailingListForm": "mailingListForm-module-scss-module___aD7VG__mailingListForm",
  "title": "mailingListForm-module-scss-module___aD7VG__title",
});
